import type { OptionDefinition } from "../types.ts";

export const cameraControlOptions: OptionDefinition[] = [
  {
    key: "zoomControl",
    type: "boolean",
    default: false,
    label: "Zoom Control",
    tab: "camera",
  },
  {
    key: "zoomControlRender",
    type: "boolean",
    default: false,
    label: "Zoom Control Render",
    tab: "camera",
  },
  {
    key: "scalarControl",
    type: "boolean",
    default: false,
    label: "Scalar Control",
    tab: "camera",
  },
  {
    key: "scalarRendering1Hand",
    type: "boolean",
    default: true,
    label: "Scalar Rendering (1 Hand)",
    tab: "camera",
    dependsOn: "scalarControl",
  },
  {
    key: "scalarRendering2Hands",
    type: "boolean",
    default: true,
    label: "Scalar Rendering (2 Hands)",
    tab: "camera",
    dependsOn: "scalarControl",
  },
  {
    key: "rotationControl",
    type: "boolean",
    default: false,
    label: "Rotation Control",
    tab: "camera",
  },
  {
    key: "rotationRendering",
    type: "boolean",
    default: true,
    label: "Rotation Rendering",
    tab: "camera",
    dependsOn: "rotationControl",
  },
  {
    key: "scalarRenderingBar",
    type: "boolean",
    default: true,
    label: "Scalar Rendering Bar",
    tab: "camera",
    dependsOn: "scalarControl",
    hidden: true,
  },
];
